module.exports = __webpack_public_path__ + "static/media/kuang-si-waterfall.ea5f4d04.jpg";